console.log('🔍 DEBUG: Brands Menu JS loaded');

document.addEventListener('DOMContentLoaded', function() {
  console.log('🔍 DEBUG: DOM ready');
  
  // Finde das Marken-Menü-Element über die ID
  const desktopMarkenDetails = document.querySelector('#Details-HeaderMenu-2');
  const mobileMarkenDetails = document.querySelector('#Details-menu-drawer-menu-item-2');
  
  console.log('🔍 DEBUG: Desktop element:', desktopMarkenDetails);
  console.log('🔍 DEBUG: Mobile element:', mobileMarkenDetails);
  
  // Finde das Mega-Menü
  const megaMenu = document.getElementById('brandsMegaMenu');
  console.log('🔍 DEBUG: Found mega menu:', megaMenu);
  
  // NEUE FUNKTION: Marken aus dem Standard-Dropdown extrahieren und Mega-Menü befüllen
  function populateMegaMenu() {
    if (!megaMenu || !desktopMarkenDetails) return;
    
    // Finde alle Links im Standard-Dropdown
    const dropdownLinks = desktopMarkenDetails.querySelectorAll('ul li a');
    console.log('🔍 DEBUG: Found dropdown links:', dropdownLinks.length);
    
    if (dropdownLinks.length === 0) return;
    
    // Extrahiere Marken-Daten und filtere "Marken" heraus
    const brands = [];
    dropdownLinks.forEach(link => {
      const brandName = link.textContent.trim();
      const brandUrl = link.getAttribute('href');
      
      // Filtere den Parent-Link heraus (endet mit #, egal in welcher Sprache)
      if (brandName && brandUrl && !brandUrl.endsWith('#')) {
        brands.push({ name: brandName, url: brandUrl });
      }
    });
    
    console.log('🔍 DEBUG: Extracted brands (after filtering):', brands.length);
    
    // Sortiere alphabetisch
    brands.sort((a, b) => a.name.localeCompare(b.name, 'de'));
    
    // Gruppiere nach Anfangsbuchstaben
    const grouped = {};
    brands.forEach(brand => {
      const firstLetter = brand.name.charAt(0).toUpperCase();
      if (!grouped[firstLetter]) {
        grouped[firstLetter] = [];
      }
      grouped[firstLetter].push(brand);
    });
    
    // Erstelle HTML für das Mega-Menü
    let megaMenuHTML = '<div class="brands-mega-menu-inner">';
    
    Object.keys(grouped).sort().forEach(letter => {
      megaMenuHTML += `<div class="brand-letter-group">`;
      megaMenuHTML += `<h3 class="brand-letter">${letter}</h3>`;
      megaMenuHTML += `<ul class="brand-list">`;
      
      grouped[letter].forEach(brand => {
        megaMenuHTML += `<li><a href="${brand.url}">${brand.name}</a></li>`;
      });
      
      megaMenuHTML += `</ul></div>`;
    });
    
    megaMenuHTML += '</div>';
    
    // Füge HTML ins Mega-Menü ein
    megaMenu.innerHTML = megaMenuHTML;
    console.log('✅ DEBUG: Mega menu populated with', brands.length, 'brands');
  }
  
  // Befülle das Mega-Menü beim Laden
  populateMegaMenu();
  
  // Funktion zum Prüfen ob Desktop-Ansicht
  function isDesktop() {
    return window.innerWidth >= 990;
  }
  
  // Funktion zum Schließen des Standard-Dropdowns
  function closeStandardDropdown(detailsElement) {
    if (detailsElement && detailsElement.hasAttribute('open')) {
      detailsElement.removeAttribute('open');
      console.log('🔍 DEBUG: Standard dropdown closed');
    }
  }
  
  // Funktion zum Behandeln des Klicks auf den Marken-Link (nur Desktop)
  function handleBrandsClick(detailsElement) {
    if (!detailsElement || !megaMenu) return;
    
    // Finde den Link innerhalb des summary-Elements
    const summary = detailsElement.querySelector('summary');
    const link = summary ? summary.querySelector('a') : null;
    
    console.log('🔍 DEBUG: Found summary:', summary);
    console.log('🔍 DEBUG: Found link:', link);
    
    // Behandle Klicks auf das gesamte Summary-Element (Link UND Caret)
    if (summary) {
      summary.addEventListener('click', function(e) {
        // Nur im Desktop-Modus das Mega-Menü verwenden
        if (!isDesktop()) {
          console.log('🔍 DEBUG: Mobile view - using standard behavior');
          return;
        }
        
        e.preventDefault();
        e.stopPropagation();
        
        console.log('🔍 DEBUG: Brands menu clicked (Desktop)!');
        
        // Schließe das Standard-Dropdown
        closeStandardDropdown(detailsElement);
        
        const isActive = megaMenu.classList.contains('active');
        console.log('🔍 DEBUG: Currently active?', isActive);
        
        if (isActive) {
          megaMenu.classList.remove('active');
          summary.classList.remove('mega-menu-open'); // NEU: Entferne Klasse
          console.log('✅ DEBUG: Menu closed');
        } else {
          megaMenu.classList.add('active');
          summary.classList.add('mega-menu-open'); // NEU: Füge Klasse hinzu
          console.log('✅ DEBUG: Menu opened');
        }
      });
      
      console.log('✅ DEBUG: Click listener attached to summary');
    }

  }
  
  // Behandle nur Desktop
  handleBrandsClick(desktopMarkenDetails);
  
  // Schließen bei Klick außerhalb (nur Desktop)
  document.addEventListener('click', function(e) {
    if (!isDesktop()) return;
    
    if (megaMenu && 
        !e.target.closest('#Details-HeaderMenu-2') && 
        !megaMenu.contains(e.target)) {
      megaMenu.classList.remove('active');
      console.log('🔍 DEBUG: Closed via outside click');
    }
  });
  
  // Schließen bei ESC (nur Desktop)
  document.addEventListener('keydown', function(e) {
    if (!isDesktop()) return;
    
    if (e.key === 'Escape' && megaMenu) {
      megaMenu.classList.remove('active');
      console.log('🔍 DEBUG: Closed via ESC key');
    }
  });
  
  // Schließe Mega-Menü bei Resize von Desktop zu Mobile
  window.addEventListener('resize', function() {
    if (!isDesktop() && megaMenu) {
      megaMenu.classList.remove('active');
    }
  });
});






/* last working::20260204 : not loading all brands
console.log('🔍 DEBUG: Brands Menu JS loaded');

document.addEventListener('DOMContentLoaded', function() {
  console.log('🔍 DEBUG: DOM ready');
  
  // Finde das Marken-Menü-Element über die ID
  const desktopMarkenDetails = document.querySelector('#Details-HeaderMenu-2');
  const mobileMarkenDetails = document.querySelector('#Details-menu-drawer-menu-item-2');
  
  console.log('🔍 DEBUG: Desktop element:', desktopMarkenDetails);
  console.log('🔍 DEBUG: Mobile element:', mobileMarkenDetails);
  
  // Finde das Mega-Menü
  const megaMenu = document.getElementById('brandsMegaMenu');
  console.log('🔍 DEBUG: Found mega menu:', megaMenu);
  
  // Funktion zum Behandeln des Klicks
  function handleBrandsClick(detailsElement) {
    if (!detailsElement || !megaMenu) return;
    
    // Finde den Link innerhalb des summary-Elements
    const summary = detailsElement.querySelector('summary');
    const link = summary ? summary.querySelector('a') : null;
    
    console.log('🔍 DEBUG: Found summary:', summary);
    console.log('🔍 DEBUG: Found link:', link);
    
    if (link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation(); // WICHTIG: Verhindert, dass das details-Element getriggert wird
        
        console.log('🔍 DEBUG: Brands link clicked!');
        
        const isActive = megaMenu.classList.contains('active');
        console.log('🔍 DEBUG: Currently active?', isActive);
        
        if (isActive) {
          megaMenu.classList.remove('active');
          console.log('✅ DEBUG: Menu closed');
        } else {
          megaMenu.classList.add('active');
          console.log('✅ DEBUG: Menu opened');
        }
      });
      
      console.log('✅ DEBUG: Click listener attached to link');
    }
  }
  
  // Behandle Desktop und Mobile
  handleBrandsClick(desktopMarkenDetails);
  handleBrandsClick(mobileMarkenDetails);
  
  // Schließen bei Klick außerhalb
  document.addEventListener('click', function(e) {
    if (megaMenu && 
        !e.target.closest('#Details-HeaderMenu-2') && 
        !e.target.closest('#Details-menu-drawer-menu-item-2') && 
        !megaMenu.contains(e.target)) {
      megaMenu.classList.remove('active');
      console.log('🔍 DEBUG: Closed via outside click');
    }
  });
  
  // Schließen bei ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && megaMenu) {
      megaMenu.classList.remove('active');
      console.log('🔍 DEBUG: Closed via ESC key');
    }
  });
});*/



/*
console.log('🔍 DEBUG: Brands Menu JS loaded');

document.addEventListener('DOMContentLoaded', function() {
  console.log('🔍 DEBUG: DOM ready');
  
  // Finde den Marken-Link
  const brandsLink = document.querySelector('a[href*="/collections/marken"]');
  console.log('🔍 DEBUG: Found brands link:', brandsLink);
  
  // Finde das Mega-Menü
  const megaMenu = document.getElementById('brandsMegaMenu');
  console.log('🔍 DEBUG: Found mega menu:', megaMenu);
  
  if (brandsLink && megaMenu) {
    console.log('✅ DEBUG: Both elements found!');
    
    brandsLink.addEventListener('click', function(e) {
      e.preventDefault();
      console.log('🔍 DEBUG: Brands link clicked!');
      
      const isActive = megaMenu.classList.contains('active');
      console.log('🔍 DEBUG: Currently active?', isActive);
      
      if (isActive) {
        megaMenu.classList.remove('active');
        console.log('✅ DEBUG: Menu closed');
      } else {
        megaMenu.classList.add('active');
        console.log('✅ DEBUG: Menu opened');
      }
    });
    
    console.log('✅ DEBUG: Click listener attached');
  } else {
    console.error('❌ DEBUG: Missing elements!', {
      brandsLink: brandsLink,
      megaMenu: megaMenu
    });
  }
  
  // Schließen bei Klick außerhalb
  document.addEventListener('click', function(e) {
    if (megaMenu && !e.target.closest('a[href*="/collections/marken"]') && !megaMenu.contains(e.target)) {
      megaMenu.classList.remove('active');
      console.log('🔍 DEBUG: Closed via outside click');
    }
  });
});
*/
/*
document.addEventListener('DOMContentLoaded', function() {
  const brandsMenuItem = document.querySelector('a[href*="marken"], a[href*="Marken"]');
  const brandsMegaMenu = document.getElementById('brandsMegaMenu');
  
  if (!brandsMenuItem || !brandsMegaMenu) return;
  
  const menuItem = brandsMenuItem.closest('li') || brandsMenuItem.parentElement;
  
  // Prevent default link behavior
  brandsMenuItem.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Toggle mega menu
    const isActive = brandsMegaMenu.classList.contains('active');
    
    // Close all other mega menus
    document.querySelectorAll('.brands-mega-menu.active').forEach(menu => {
      if (menu !== brandsMegaMenu) {
        menu.classList.remove('active');
      }
    });
    
    // Toggle current menu
    brandsMegaMenu.classList.toggle('active');
  });
  
  // Close menu when clicking outside
  document.addEventListener('click', function(e) {
    if (!menuItem.contains(e.target) && !brandsMegaMenu.contains(e.target)) {
      brandsMegaMenu.classList.remove('active');
    }
  });
  
  // Close menu on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      brandsMegaMenu.classList.remove('active');
    }
  });
  
  // Keep menu open when hovering over it
  menuItem.addEventListener('mouseenter', function() {
    // Optional: Auto-open on hover
    // brandsMegaMenu.classList.add('active');
  });
  
  menuItem.addEventListener('mouseleave', function(e) {
    // Optional: Auto-close on mouse leave
    // setTimeout(() => {
    //   if (!brandsMegaMenu.matches(':hover')) {
    //     brandsMegaMenu.classList.remove('active');
    //   }
    // }, 200);
  });
});
*/